import { AxiosInstance } from "axios"

import store from "../../store/store"
import * as authAction from "../../store/auth/actions"
import { isEmpty } from "../../helpers/object"

export default ($axios: AxiosInstance) => {
  const isProduction = process.env.PRODUCTION_ENVIRONMENT === "true";
  $axios.interceptors.request.use((config) => {
    if(!isProduction) {
      console.log(
        '[API]',
        `[${config.method?.toUpperCase()}] ${config.url}`,
        `${'\n'}${JSON.stringify(config.params || config.data, undefined, 2)}`,
      );
    }
    return config
  })

  $axios.interceptors.response.use(
    (response) => {
      if(!isProduction) {
        console.log(`[RETURN DATA] : ${response.config.url}`, response.data);
      }
      if (isErrorOccurred(response)) {
        return throwNormalizedError(response.data)
      }

      return response.data
    },
    (error) => {
      return throwNormalizedError(error)
    }
  )
}

const isErrorOccurred = (response: any) => {
  if (response.data.code !== 200) {
    return response.data
  }

  return false
}

const throwNormalizedError = (error: any) => {
  let customError

  if (error.code) {
    // Internal Error
    let response = {
      type: "Internal Error",
      code: error.code,
      message: error.message
    }

    if (error.data) {
      response = { ...response, ...{ data: error.data } }
    }

    customError = response
  } else {
    // External Error
    const response = {
      type: "External Error",
      code: error.response?.status,
      message: error.message
    }
    customError = response
  }

  switch (customError.code) {
    case 502:
      if (!isEmpty(store.getState().auth.auth)) {
        store.dispatch(authAction.logout())
      }
      return Promise.reject(customError)
    default:
      return Promise.reject(customError)
  }
}
